module.exports = __webpack_public_path__ + "img/148.4dae6ac2.jpg";